// --- Views
import SelectCreditRange from '@/views/shared/credit/SelectCreditRange.vue';
import CreditIntro from '@/views/shared/CreditIntro.vue';
import NameForm from '@/views/shared/NameForm.vue';
import AddressForm from '@/views/shared/AddressForm.vue';
import DateOfBirthForm from '@/views/shared/DateOfBirthForm.vue';
import ContactDetailsForm from '@/views/shared/ContactDetailsForm.vue';
import ConfirmCreditForm from '@/views/shared/ConfirmCreditForm.vue';
import VerifyCreditForm from '@/views/shared/VerifyCreditForm.vue';
import CreditResults from '@/views/shared/credit/CreditResults.vue';
import ErrorView from '@/views/shared/ErrorPageV2.vue';

export default [
  {
    path: '',
    redirect: { path: 'select-credit-range' },
  },
  {
    path: 'select-credit-range',
    component: SelectCreditRange,
    meta: {
      headerIcon: 'back',
      hasNext: false,
    },
  },
  {
    path: 'credit-intro',
    component: CreditIntro,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 0,
        to: 1,
      },
      numberOfSteps: 8,
      hasNext: true,
      nextRoutePath: 'name-form',
    },
  },
  {
    path: 'name-form',
    component: NameForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 8,
      hasNext: true,
      nextRoutePath: 'address-form',
    },
  },
  {
    path: 'address-form',
    component: AddressForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 2,
        to: 3,
      },
      numberOfSteps: 8,
      hasNext: true,
      nextRoutePath: 'date-of-birth-form',
    },
  },
  {
    path: 'date-of-birth-form',
    component: DateOfBirthForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 3,
        to: 4,
      },
      numberOfSteps: 8,
      hasNext: true,
      nextRoutePath: 'contact-details-form',
    },
  },
  {
    path: 'contact-details-form',
    component: ContactDetailsForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 4,
        to: 5,
      },
      numberOfSteps: 8,
      hasNext: true,
      nextRoutePath: 'confirm-credit-form',
    },
  },
  {
    path: 'confirm-credit-form',
    component: ConfirmCreditForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 5,
        to: 6,
      },
      numberOfSteps: 8,
      hasNext: true,
      nextRoutePath: false,
    },
  },
  {
    path: 'verify-credit-form',
    component: VerifyCreditForm,
    meta: {
      headerIcon: false,
      navInfo: {
        from: 6,
        to: 7,
      },
      numberOfSteps: 8,
      hasNext: true,
      nextRoutePath: 'credit-results',
    },
  },
  {
    path: 'credit-results',
    component: CreditResults,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: true,
    },
  },
  {
    path: 'credit-error',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: true,
      errorPayload: {
        errorType: 'credit',
        errorMsg: 'default',
        buttonText: 'continuePayment',
      },
    },
  },
  // Subflow general error route
  {
    path: 'error',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: true,
      errorPayload: {
        errorType: 'general',
        errorMsg: 'subFlow',
        buttonText: 'continuePayment',
      },
    },
  },
  {
    path: '*',
    redirect: { path: 'error' },
  },
];
